export default "__VITE_ASSET__DXKNsX2j__"